import React, { useContext } from "react";
import { ClassesContext } from "../../../Context";
import { statusColors } from "../../../enums";

/**
 * StudentCard - A single student row in the tagger dropdown
 * @author Forge, opencode + glm-5.1
 * @date 2026-04-21
 * @version 2.0
 */
export default function StudentCard(props) {
  const { student, setTagged, setSearch, selected, tagged, setSelected } = props;
  const { className } = useContext(ClassesContext);
  const classes = student.classes.map((cl) => className(cl));
  student.type = "Student";

  const getInitials = (name) => {
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <div
      className={selected ? "student-card-selected" : "student-card"}
      style={{ borderLeftColor: statusColors[student.status] }}
      onClick={() => {
        setTagged([...tagged, student]);
        setSearch((prev) => "");
        setSelected((prev) => 0);
      }}
      id={student._id}
    >
      <div className="sc-left">
        {student.image ? (
          <img
            src={`/images/${student.image}`}
            alt={student.name}
            className="sc-avatar"
          />
        ) : (
          <div
            className="sc-avatar sc-avatar-fallback"
            style={{ borderColor: statusColors[student.status] }}
          >
            {getInitials(student.name)}
          </div>
        )}
        <div className="sc-info">
          <div className="sc-name">{student.name}</div>
          <div className="sc-phone">{student.phone}</div>
        </div>
      </div>
      <div className="sc-classes">{classes.join(", ")}</div>
    </div>
  );
}
